import { useTradeSalesStore } from "@fero/stores";
import { Grid } from "@mui/material";
import { BaseWizardCard } from "components/library/widgets/wizard-card/base-wizard-card";
import { RadioGroup } from "components/widgets/inputs/radio-group/radio-group";

interface DeliveryTypeCardProps {
  isBonded: boolean;
  onChange: (isBonded: boolean) => void;
}
export const DeliveryTypeCard = ({
  isBonded,
  onChange,
}: DeliveryTypeCardProps) => {
  const { options } = useTradeSalesStore();
  return (
    <BaseWizardCard
      title={"Sale Price Selection"}
      subtitle={"Does the sale price you are entering include or exclude duty?"}
      inputElement={
        <Grid container spacing={0}>
          <RadioGroup
            options={[
              {
                value: "true",
                label: "In-Bond / Underbond",
                disabled: options.isEditMode,
              },
              {
                value: "false",
                label: "Out-of-Bond / Duty Paid",
                disabled: options.isEditMode,
              },
            ]}
            value={isBonded ? "true" : "false"}
            onChange={(value) => {
              const isBonded = value === "true";
              onChange(isBonded);
            }}
          />
        </Grid>
      }
    />
  );
};
